import { atom } from 'jotai';
import { Message, MessageCategory, MessageCategoryEnum } from '../../types';
import { Loadable, LoadableState } from '../../utils';

export type MessageGroup = Array<Message>;

export type MessageGroups = {
  groups: Record<MessageCategory, MessageGroup>;
};

export type UnreadNotificationsAmount = {
  count: number;
  // Timestamp to be easily serializable over BroadcastChannel
  updated: number;
};

export const defaultMessageGroups: Record<MessageCategory, MessageGroup> = {
  [MessageCategory.Event]: [],
  [MessageCategory.Promotion]: [],
  [MessageCategory.Technical]: [],
};

export const messageGroupsAtom = atom<LoadableState<MessageGroups>>(Loadable.uninitialized);

// This is being updated by the user stream, when the server thinks the notification count changed.
// Don't use directly, unless you are recieving data from the user stream,
// use useNotifications#unreadMessagesCount instead for displaying this on the UI.
export const unreadMessagesCountAtom = atom<UnreadNotificationsAmount>({
  count: 0,
  updated: Date.now(),
});

export const showOnlyUnreadNotificationsAtom = atom<boolean>(false);

export const activeNotificationCategoryAtom = atom<MessageCategoryEnum>(MessageCategoryEnum.Event);
